import { z } from 'zod'

import { Product } from '@/types/catalogue/product'
import { ArticleOrder, StatusOrder } from '@/types/operations/order'

/** The step of the order creation. */
export const StatusOrderKonvives = z.enum([
    StatusOrder.enum.IN_PREPARATION,
    StatusOrder.enum.ON_DELIVERY,
    StatusOrder.enum.READY,
])

export type StatusOrderKonvives = z.infer<typeof StatusOrderKonvives>

/** The step of the order creation. */
export const StepOrderCreateKonvives = z.enum([
    'PRODUCTS',
    'SITE',
    'CONFIRMATION',
])

export type StepOrderCreateKonvives = z.infer<typeof StepOrderCreateKonvives>

export const ArticleCart = ArticleOrder.extend({
    product: Product.shape.id,
})

export type ArticleCart = z.infer<typeof ArticleCart>
